// extracted by mini-css-extract-plugin
module.exports = {"container":"triangle_container__kxMbI"};